import { TRuleSources } from 'meta/rule_sources'

const rule_sources = {
  BATTLETOME_FYRESLAYERS: {
    name: 'Battletome: Fyreslayers',
    type: 'battletome',
  },
} satisfies TRuleSources

export default rule_sources
